var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/address-2.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-form__field\">\n\n    <label for=\"address.address2\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 2, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address2_group2",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group2" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8") {
output += "\n\n    <input type=\"text\" id=\"address.address2\" name=\"address.address2\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup(((lineno = 6, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"address2")), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" data-qa-address-form-address2-field aria-describedby=\"address.address2_error\"/>\n\n    ";
;
}
else {
output += "\n\n    <input type=\"text\" id=\"address.address2\" name=\"address.address2\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup(((lineno = 10, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"address2")), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue((lineno = 10, colno = 135, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address-placeholder-address2",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" data-qa-address-form-address2-field aria-describedby=\"address.address2_error\"/>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/address-2.j2"] , dependencies)